const state = {
  homeTypes: [
    { name: 'Страхування квартири', id: 'flat' },
    { name: 'Страхування будинку', id: 'house' },
  ],
  homeAmounts: [
    { name: '500 000 ₴', id: 500000 },
    { name: '700 000 ₴', id: 700000 },
    { name: '1 000 000 ₴', id: 1000000 },
    { name: '1 500 000 ₴', id: 1500000 },
    { name: '2 000 000 ₴', id: 2000000 },
    { name: '2 500 000 ₴', id: 2500000 },
    { name: '3 000 000 ₴', id: 3000000 },
    { name: '4 000 000 ₴', id: 4000000 },
    { name: '5 000 000 ₴', id: 5000000 },
  ],
  homePeriods: [
    { name: '5 місяців', id: '5m' },
    { name: '6 місяців', id: '6m' },
    { name: '7 місяців', id: '7m' },
    { name: '8 місяців', id: '8m' },
    { name: '9 місяців', id: '9m' },
    { name: '10 місяців', id: '10m' },
    { name: '11 місяців', id: '11m' },
    { name: '12 місяців', id: '12m' },
  ],
};

const getters = {
  HOME_TYPES: state => state.homeTypes,
  HOME_AMOUNTS: state => state.homeAmounts,
  HOME_PERIODS: state => state.homePeriods,
};

export default {
  state,
  getters
};
